import * as Path from './apiRoutes';
import ApiService from "../../../../utils/apiService";
import { MSG_DEFAULT_ERROR } from "../../../../utils/messages";
import { NOTIF_ERROR, NOTIF_SUCCESS, SUCCESS } from "../../../../utils/constants";
import { SideNotification } from "../../../../utils/common";
import * as Actions from './actions';

export const getBannerAnnouncements = (isSubscribed) => () => {
    let params = new FormData();
    params.append("isSubscribed", isSubscribed)

    return ApiService.post(Path.BANNER_GET, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const updateBannerAnnouncement = (genericAnnouncement, timeboundAnnouncement, isSubscribed) => () => {
    let params = new FormData();
    params.append("isSubscribed", isSubscribed);
    params.append("strAnnouncementDetails", JSON.stringify(genericAnnouncement))
    params.append("strTimeboundDetails", JSON.stringify(timeboundAnnouncement))
    return ApiService.post(Path.BANNER_UPDATE, params)
        .then((response) => {
            if (SUCCESS === response.data.status) {
                SideNotification(NOTIF_SUCCESS, response.data.message)
            } else {
                SideNotification(NOTIF_ERROR, response.data.message)
            }
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const getPopupList = (filter) => (dispatch) => {
    return ApiService.post(Path.POPUP_LIST, filter)
        .then((response) => {
            if(SUCCESS === response.data.status){
                dispatch(Actions.setPopupList(response.data.data.popupList))
            }else{
                SideNotification(NOTIF_ERROR, response.data.message)
            }
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const insertPopupAnnouncement = (popupDetails) => () => {
    return ApiService.post(Path.POPUP_INSERT, popupDetails)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const updatePopupAnnouncement = (popupDetails) => () => {
    return ApiService.post(Path.POPUP_UPDATE, popupDetails)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};


export const getPopupById = (popupId) => () => {
    return ApiService.get(Path.POPUP_ROOT+`/${popupId}`)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const deletePopup = (popupId) => () => {
    return ApiService.delete(Path.POPUP_ROOT, popupId)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const sendPushNotif = (pushTitle, pushBody) => (dispatch) => {
    const params = new FormData();
    params.append("title", JSON.stringify(pushTitle));
    params.append("body", JSON.stringify(pushBody));
    return ApiService.post(Path.PUSH_TOKEN_ROOT + "/allPushTokens", params)
        .then((response) => {
            return response.data
        }).catch((error) => {
            console.log(error)
        });
}

export const getAllVideos = () => (dispatch) => {
    return ApiService.get(Path.GAME_VIDEO_ROOT + "/allVideos")
        .then((response) => {
            if(SUCCESS === response.data.status){
                dispatch(Actions.setVideoList(response.data.data.videoList))
            }else{
                SideNotification(NOTIF_ERROR, response.data.message)
            }
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const getVideoById = (videoId) => () => {
    return ApiService.get(Path.GAME_VIDEO_ROOT+`/gameVideo/${videoId}`)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const insertGameVideo = (videoDetails) => () => {
    const params = new FormData();
    params.append("gameVideoDetails", JSON.stringify(videoDetails));
    return ApiService.post(Path.GAME_VIDEO_INSERT, params)
        .then((response) => {
            return response.data
        }).catch((error) => {
            console.log(error)
        });
};

export const updateGameVideo = (videoDetails) => () => {
    return ApiService.post(Path.GAME_VIDEO_UPDATE, videoDetails)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const deleteVideo = (videoId) => () => {
    return ApiService.post(Path.GAME_VIDEO_ROOT+`/gameVideo/delete/${videoId}`)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};